import { render, staticRenderFns } from "./privateServices.vue?vue&type=template&id=08a34416&scoped=true&"
import script from "./privateServices.vue?vue&type=script&lang=js&"
export * from "./privateServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a34416",
  null
  
)

export default component.exports